import React, { useMemo } from 'react'
import { Decryption } from 'Utils/encryptionPassword'
import NumberConversion from 'Utils/NumberConversion'
import Spinner from 'Common/Spinner';
import PDFViewer from 'Components/PDFViewer/PDFViewer';

const PaymentPortalStatementDetails = ({ model, authResponse, handleAuthenticate }) => {
    const statementFileUrl = useMemo(() => {
        if (!authResponse?.patient?.invoiceUrl) {
            return '';
        }
        return Decryption(authResponse.patient.invoiceUrl);
    }, [authResponse?.patient?.invoiceUrl]);

    return (
        // Changed grid-cols to stack on mobile/tablet and split on large screens (iPad Pro/Desktop)
        <div className="grid min-h-screen grid-cols-1 bg-white lg:grid-cols-12">

            {/* Left Section: Payment Details */}
            <div
                className="flex justify-center px-6 py-10 md:px-12 lg:col-span-5 lg:px-8 lg:pt-16 lg:pb-10 lg:h-screen lg:sticky lg:top-0"
                style={{ boxShadow: "rgba(0, 0, 0, 0.05) 5px 0px 5px -2px" }}
            >
                <div className="w-full max-w-md space-y-6">
                    {/* Practice Header */}
                    <div className="flex items-center gap-3">
                        <div className="flex items-center justify-center w-10 h-10 rounded-full shadow-md bg-gray-50">
                            <span className="font-semibold text-md">🏥</span>
                        </div>
                        <h2 className="font-semibold text-gray-800 text-md">{authResponse.patient.practiceName}</h2>
                    </div>

                    {/* Balance Info */}
                    <div className="space-y-1">
                        <p className="text-sm font-medium tracking-wider uppercase text-secondaryLight">
                            {model.loginModel.invoiceNumber}
                        </p>
                        <p className="text-4xl font-semibold text-secondary md:text-4xl">
                            {NumberConversion(authResponse.patient.invoiceBalance)}
                        </p>
                        <p className="pt-1 text-sm font-semibold text-secondaryLight">
                            {authResponse.patient.invoiceDescriptor}
                        </p>
                    </div>

                    {/* CTA Section */}
                    <div>
                        {authResponse.patient.doStripePartners ? (
                            <button
                                onClick={() => handleAuthenticate(authResponse)}
                                className="w-full bg-gradient-to-r from-indigo-500 to-purple-500 hover:from-indigo-600 hover:to-purple-600 text-white font-semibold py-4 rounded-xl transition-all duration-200 transform hover:scale-[1.01] active:scale-[0.98] focus:ring-4 focus:ring-indigo-200 focus:outline-none shadow-lg flex justify-center items-center gap-2"
                            >
                                <span>Pay Now</span>
                                {model.loader && <Spinner size={18} />}
                            </button>
                        ) : (
                            <div className="p-4 border border-gray-200 rounded-lg bg-gray-50">
                                <div className="mb-1 font-bold text-primary">Payment Notice</div>
                                <p className="text-sm leading-relaxed text-secondaryLight">
                                    To make a payment, please call our office or mail a check to the mailing address given on the statement.
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Right Section: PDF Preview */}
            <div className="px-6 py-10 lg:col-span-7 lg:px-10 lg:py-8 lg:h-screen lg:overflow-y-auto">
                <div className="max-w-5xl mx-auto">
                    <span className="block mb-6 text-xl font-bold text-gray-800">Statement Preview</span>

                    <div className="bg-white p-3 md:p-5 shadow-inner border-[3px] border-dashed border-[#cfd7e7] rounded-xl">
                        {/* Note: Ensure PDFViewer internal styles are responsive. 
                            If it has a fixed width, wrap it in an overflow-x-auto div.
                        */}
                        <div className="overflow-hidden rounded-lg">
                            <PDFViewer fileUrl={statementFileUrl} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PaymentPortalStatementDetails